module.exports = "/static/assets/42428924171999cebe3efd5e70b7bc53.svg";